function applyScript() {
  setTimeout(function(){
    const boldOptionValuePrices = document.querySelectorAll('.bold_option_value_price');
    boldOptionValuePrices.forEach(element => {
console.log("BOLD CUSTOM JS")
      const originalText = element.textContent;
      const newText = originalText + " 円(税込)"; // Replace "Your Appended Text Here" with the desired text you want to add
      element.textContent = newText;
    });
  }, 800);
}

function observeDOM() {
  var observer = new MutationObserver(function(mutationsList) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
        // applyScript();
        observer.disconnect();
        break;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', function() {
  console.log("BOLD CUSTOM JS")
  observeDOM();
  setTimeout(function(){
    applyScript()
  },1500)
    
});